
import { Card, CardContent } from "@/components/ui/card";
import { User } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { useTranslations } from "@/hooks/useTranslations";

interface AboutSectionProps {
  aboutMe: string;
}

export const AboutSection = ({ aboutMe }: AboutSectionProps) => {
  const { t } = useTranslations("publicProfile");
  
  if (!aboutMe) return null;
  
  return (
    <Card className="border-none shadow-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm overflow-hidden">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <User className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{t("aboutMe")}</h2>
        </div>
        <div className="border-l-4 border-gray-200 dark:border-gray-700 pl-4 py-1">
          <p className="text-muted-foreground whitespace-pre-wrap leading-relaxed dark:text-gray-300">{aboutMe}</p>
        </div>
      </CardContent>
    </Card>
  );
};
